<ng-content select="vx-sidebar-header"></ng-content>
<div class="flex min-h-0 flex-1 flex-col overflow-y-auto">
  <ng-content></ng-content>
</div>
<ng-content select="vx-sidebar-footer"></ng-content>
